<template>
  <div
    class="col"
    data-cy="handover-keys-step">
    <div class="text-center text-danger my-2" />
    <div
      class="row">
      <div class="col-md-5">
        <h3 data-cy="handover-keys-existing-title">
          {{ source === 'template' ? $t('message.processHandoverTemplate.addKeys') : $t('message.processHandover.keys.existingKeys') }}
          <coozzy-info-circle-icon
            v-if="source !== 'template'"
            v-b-tooltip.hover.html="$t('message.processHandover.keys.existingKeysTooltip')"
            class="ml-2 mb-2 tooltip-message" />
        </h3>
        <p
          v-if="source !== 'template'"
          class="mb-0">
          {{ $t('message.processHandover.keys.existingKeysSubtitle') }}
        </p>
        <div
          class="list-group">
          <div
            v-for="device in filteredSelectedKeys"
            :key="(device.id || device.internalId) + '-' + device.type"
            :class="['list-group-item']"
            data-cy="handover-keys-existing-item">
            <span data-cy="handover-keys-existing-item-name">{{ device.type === 'DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER' && object && object.category === 'PARKING_SPACE' ? $t('message.processHandover.keys.listEntryTitleKey') + '"' + $t('message.processHandover.keys.listEntryTitleWireless') + '"' : (device.type === 'DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER' && (!object || object.category !== 'PARKING_SPACE') ? $t('message.processHandover.keys.listEntryTitleWireless') : $t('message.processHandover.keys.listEntryTitleKey')) + (device.lockingKey?.description !== '' ? ' "' + device.lockingKey?.description + '"' : '') }}</span>
            <coozzy-button
              data-cy="handover-keys-existing-item-delete-button"
              design="transparent"
              class="p-0 ml-1 mb-2 float-right"
              @click="showDeleteConfirmation(device, $event)">
              <coozzy-delete-icon />
            </coozzy-button>
            <coozzy-button
              data-cy="handover-keys-existing-item-edit-button"
              design="transparent"
              class="p-0 mb-2 float-right ml-2"
              @click="editDevice(device)">
              <coozzy-edit-icon />
            </coozzy-button>
          </div>
        </div>
        <coozzy-button
          data-cy="handover-keys-add-key-button"
          class="col-sm-12 col-lg-4 col-md-4 float-md-right mt-3"
          design="prop-green"
          @click="addKey">
          {{ $t('message.processHandover.keys.addKey') }}
        </coozzy-button>
        <b-modal
          :id="'editDevice'"
          ref="editDevice"
          :key="internalKey"
          data-cy="handover-keys-edit-modal"
          no-close-on-backdrop
          :title="$t('message.onBoarding.buildings.objects.renovation.editDevice.title')"
          hide-footer>
          <div class="col">
            <device
              v-if="deviceToEdit"
              ref="object-device"
              :target="'object'"
              :from-handover="true"
              :from-key-step="true"
              :handover-rooms="preSelectedRooms"
              :device="deviceToEdit"
              :expand-by-default="true"
              :owner-id="object?.ownerId"
              @device-update="deviceUpdated" />
          </div>
          <div class="col mt-2">
            <coozzy-button
              data-cy="handover-keys-edit-cancel-button"
              size="small"
              class="float-left mb-0 border"
              design="transparent"
              @click="$bvModal.hide('editDevice')">
              {{ $t('message.generic.cancel') }}
            </coozzy-button>
            <coozzy-button
              data-cy="handover-keys-edit-save-button"
              design="green"
              class="float-right ml-3"
              @click="saveDevice()">
              {{ $t('message.generic.form.save') }}
            </coozzy-button>
          </div>
        </b-modal>
      </div>
      <div class="col-md-5 offset-2">
        <h3 data-cy="handover-keys-suggestions-title">
          {{ $t('message.processHandover.keys.suggestionsKeys.title') }}
          <coozzy-info-circle-icon
            v-if="!templateObject"
            v-b-tooltip.hover.html="$t('message.processHandover.keys.suggestionsKeysTooltip')"
            class="ml-2 mb-2 tooltip-message" />
        </h3>
        <p
          v-if="templateObject"
          class="m-0"
          data-cy="handover-keys-template-name">
          {{ $t('message.settings.template.template') }}: {{ templateObject.name }}
        </p>
        <p
          v-else
          class="mb-0">
          {{ $t('message.processHandover.keys.suggestionsKeysSubtitle') }}
        </p>
        <coozzy-card class="list-group w-100 p-0">
          <div
            v-for="keyItem in computedAvailableKeys"
            :key="keyItem.id"
            class="list-group-item"
            data-cy="handover-keys-suggestion-item">
            <span data-cy="handover-keys-suggestion-item-name">
              {{ $t('message.processHandover.keys.listEntryTitleKey') + (keyItem.lockingKey?.description ? ' "' + keyItem.lockingKey.description + '"' : '') }}
            </span>
            <coozzy-button
              data-cy="handover-keys-suggestion-item-add-button"
              design="prop-green"
              class="p-0 ml-1 float-right px-2 add-to-available"
              @click="addKeyMethod(keyItem)">
              +
            </coozzy-button>
          </div>
        </coozzy-card>
        <b-modal
          :id="'confirmationModalDeleteKey_' + objectId"
          :ref="'confirmationModalDeleteKey_' + objectId"
          data-cy="handover-keys-delete-confirm-modal"
          no-close-on-backdrop
          hide-footer
          :title="$t('message.processHandover.confirmationDeletion.title')">
          <template>
            <div class="col p-0">
              <p>{{ $t('message.processHandover.confirmationDeletion.body') }}</p>
            </div>
            <div class="col p-0">
              <coozzy-button
                data-cy="handover-keys-delete-cancel-button"
                size="small"
                class="mb-0 border"
                design="transparent"
                @click="$bvModal.hide('confirmationModalDeleteKey_' + objectId)">
                {{ $t('message.generic.cancel') }}
              </coozzy-button>
              <coozzy-button
                data-cy="handover-keys-delete-confirm-button"
                size="small"
                class="float-right mb-0"
                design="green"
                @click="deleteOneKey()">
                {{ $t('message.generic.delete') }}
              </coozzy-button>
            </div>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { deviceUtils } from '@/mixins/deviceUtils'
import CoozzyEditIcon from '@/framework/components/icons/CoozzyEditIcon.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import CoozzyDeleteIcon from '@/framework/components/icons/CoozzyDeleteIcon.vue'
import CoozzyInfoCircleIcon from '@/framework/components/icons/CoozzyInfoCircleIcon.vue'
import Device from '@/building/tabs/components/Device.vue'
import CoozzyCard from '@/framework/components/card/CoozzyCard.vue'
import {
  ObjectobjectObject,
  ObjectdeviceDevice,
  ObjecthandoverProtocolTemplate,
  DeviceLockingKey,
  DeviceCostsInterval
} from '@/types/api'
import { HandoverDevice, HandoverRoom } from '@/types/models'

export default Vue.extend({
  name: 'HandoverKeysStep',
  components: {
    CoozzyCard,
    Device,
    CoozzyInfoCircleIcon,
    CoozzyDeleteIcon,
    CoozzyButton,
    CoozzyEditIcon
  },
  mixins: [deviceUtils],
  props: {
    object: {
      type: Object as PropType<ObjectobjectObject | null>,
      default: () => null
    },
    preSelectedRooms: {
      type: Array as PropType<HandoverRoom[]>,
      default: () => []
    },
    initKeys: {
      type: Array as PropType<HandoverDevice[]>,
      default: () => []
    },
    handoverDeletedDeviceIds: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    source: {
      type: String,
      required: false,
      default: () => ''
    },
    templateObject: {
      type: Object as PropType<ObjecthandoverProtocolTemplate | null>,
      default: () => null
    },
    suggestionDevices: {
      type: Array as PropType<HandoverDevice[]>,
      default: () => []
    }
  },
  data() {
    return {
      selectedDevice: null as HandoverDevice | null,
      deviceToEdit: null as HandoverDevice | null,
      internalKey: 0 as number,
      selectedKeys: [] as HandoverDevice[],
      deletedKeys: [] as string[],
      keys: [] as HandoverDevice[],
      availableKeys: [
        { internalId: 1, name: 'basement', category: 1, value: 'message.processHandover.keys.suggestionsKeys.basement', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.basement') as string, lockingPlanNumber: '' } },
        { internalId: 2, name: 'attic', category: 1, value: 'message.processHandover.keys.suggestionsKeys.attic', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.attic') as string, lockingPlanNumber: '' } },
        { internalId: 3, name: 'washingCard', category: 1, value: 'message.processHandover.keys.suggestionsKeys.washingCard', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.washingCard') as string, lockingPlanNumber: '' } },
        { internalId: 4, name: 'letterbox', category: 1, value: 'message.processHandover.keys.suggestionsKeys.letterbox', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.letterbox') as string, lockingPlanNumber: '' } },
        { internalId: 5, name: 'flatKey', category: 1, value: 'message.processHandover.keys.suggestionsKeys.flatKey', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.flatKey') as string, lockingPlanNumber: '' } },
        { internalId: 6, name: 'garage', category: 2, value: 'message.processHandover.keys.suggestionsKeys.garage', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.garage') as string, lockingPlanNumber: '' } },
        { internalId: 7, name: 'handTransmitter', category: 2, value: (this.object && this.object.category === 'PARKING_SPACE') ? 'message.processHandover.keys.listEntryTitleWireless' : 'message.processHandover.keys.suggestionsKeys.handTransmitter', type: 'DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.handTransmitter') as string, lockingPlanNumber: '' } }
      ] as HandoverDevice[]
    }
  },
  computed: {
    objectId(): string {
      return this.object?.id || 'template'
    },
    accountId(): string | null {
      return this.$store.getters['user/getAccountId'] || null
    },
    computedAvailableKeys(): HandoverDevice[] {
      if (!this.object || this.templateObject) {
        return this.availableKeys
      } else if (['APARTMENT', 'HOUSE', 'COMMERCIAL', 'SECONDARY_ROOM', 'GASTRONOMY'].includes(this.object.category)) {
        return this.availableKeys.filter(k => k.category === 1).sort((a, b) => this.$t(a.value).localeCompare(this.$t(b.value)))
      } else if (this.object.category === 'PARKING_SPACE') {
        return this.availableKeys.filter(k => k.category === 2).sort((a, b) => this.$t(a.value).localeCompare(this.$t(b.value)))
      }
      return []
    },
    filteredSelectedKeys(): HandoverDevice[] {
      return this.selectedKeys
        .filter(key => !this.isDeviceUninstalledInPast(key))
        .sort((a, b) => a.order - b.order)
    }
  },
  watch: {
    initKeys(newVal: HandoverDevice[], oldVal: HandoverDevice[]) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.keys = newVal
        this.updateSelectedKeys(false)
      }
    },
    deletedKeys(newVal: string[]) {
      this.$emit('add-init-key')
      this.$emit('deleted-keys', newVal, this.object)
    },
    handoverDeletedDeviceIds(newVal: string[]) {
      this.deletedKeys = Array.from(new Set([...this.deletedKeys, ...newVal]))
    },
    suggestionDevices(newVal: HandoverDevice[], oldVal: HandoverDevice[]) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.initAvailableKeys()
      }
    },
    '$i18n.locale'() {
      if (!this.suggestionDevices || this.suggestionDevices.length === 0) {
        this.initAvailableKeys()
      }
    }
  },
  mounted() {
    this.addPropertiesToDevices()
    if (this.handoverDeletedDeviceIds?.length > 0) {
      this.deletedKeys = [...this.handoverDeletedDeviceIds]
    }
    this.updateSelectedKeys()
    this.initAvailableKeys()
  },
  methods: {
    ...mapActions('employee', ['loadEmployees']),
    ...mapGetters('employee', ['getEmployees']),

    initAvailableKeys() {
      if (this.suggestionDevices && this.suggestionDevices.length > 0) {
        this.availableKeys = this.suggestionDevices.filter((d: HandoverDevice) => d.roomId === '' || !d.roomId).map((d: HandoverDevice) => ({
          ...d,
          lockingKey: d.lockingKey || { combinedKeys: false, combinedKeysNote: '', description: '', lockingPlanNumber: '' },
          referenceId: d.referenceId || this.objectId
        }))
      } else {
        this.availableKeys = [
          { internalId: 1, name: 'basement', category: 1, value: 'message.processHandover.keys.suggestionsKeys.basement', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.basement') as string, lockingPlanNumber: '' } },
          { internalId: 2, name: 'attic', category: 1, value: 'message.processHandover.keys.suggestionsKeys.attic', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.attic') as string, lockingPlanNumber: '' } },
          { internalId: 3, name: 'washingCard', category: 1, value: 'message.processHandover.keys.suggestionsKeys.washingCard', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.washingCard') as string, lockingPlanNumber: '' } },
          { internalId: 4, name: 'letterbox', category: 1, value: 'message.processHandover.keys.suggestionsKeys.letterbox', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.letterbox') as string, lockingPlanNumber: '' } },
          { internalId: 5, name: 'flatKey', category: 1, value: 'message.processHandover.keys.suggestionsKeys.flatKey', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.flatKey') as string, lockingPlanNumber: '' } },
          { internalId: 6, name: 'garage', category: 2, value: 'message.processHandover.keys.suggestionsKeys.garage', type: 'DEVICE_TYPE_LOCKING_KEY', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.garage') as string, lockingPlanNumber: '' } },
          { internalId: 7, name: 'handTransmitter', category: 2, value: (this.object && this.object.category === 'PARKING_SPACE') ? 'message.processHandover.keys.listEntryTitleWireless' : 'message.processHandover.keys.suggestionsKeys.handTransmitter', type: 'DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER', lockingKey: { combinedKeys: false, combinedKeysNote: '', description: this.$t('message.processHandover.keys.suggestionsKeys.handTransmitter') as string, lockingPlanNumber: '' } }
        ] as HandoverDevice[]
      }
    },
    getRoomName(roomId: string): string {
      const room = this.findRoomById(roomId)
      return room ? room.name : 'Unknown Room'
    },
    findRoomById(roomId: string): HandoverRoom | null {
      if (!this.preSelectedRooms) return null
      return this.preSelectedRooms.find(room => room.id === roomId)
    },
    updateSelectedKeys(dropUnsaved = false) {
      const newSelectedKeys = [...this.initKeys]

      if (!dropUnsaved) {
        // Add any new keys from this.keys that are of the correct type and not already present
        this.keys.forEach(key => {
          if (key.id?.startsWith('device_') &&
              (key.type === 'DEVICE_TYPE_LOCKING_KEY' || key.type === 'DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER')) {
            const existingIndex = newSelectedKeys.findIndex(k => k.id === key.id)
            if (existingIndex === -1) {
              newSelectedKeys.push(key)
            }
          }
        })

        this.selectedKeys.forEach(existingKey => {
          const existingIndex = newSelectedKeys.findIndex(k => k.id === existingKey.id)
          if (existingIndex !== -1) {
            if (existingKey.edited) {
              newSelectedKeys[existingIndex] = existingKey
            }
          } else if (existingKey.id?.startsWith('device_')) {
            newSelectedKeys.push(existingKey)
          }
        })
      }

      this.selectedKeys = newSelectedKeys
        .filter(key => !this.deletedKeys.includes(key.id))
        .filter((key, index, self) =>
          index === self.findIndex(t => t.id === key.id)
        )
    },
    saveDevice() {
      if (!this.deviceToEdit) {
        this.$refs.editDevice.hide()
        return
      }

      const deviceCopy = JSON.parse(JSON.stringify(this.deviceToEdit))
      deviceCopy.edited = true

      if (deviceCopy.roomId) {
        const room = this.findRoomById(deviceCopy.roomId)
        if (room) {
          const updatedRooms = [...this.preSelectedRooms]
          const roomIndex = updatedRooms.findIndex(r => r.id === room.id)
          if (roomIndex !== -1) {
            const deviceIndex = updatedRooms[roomIndex].devices.findIndex(d => d.id === deviceCopy.id)
            if (deviceIndex !== -1) {
              updatedRooms[roomIndex].devices[deviceIndex] = deviceCopy
              this.$emit('selected-rooms', { object: null, rooms: updatedRooms }, this.object, 'device')
            }
          }
        }
      } else {
        const deviceIndex = this.selectedKeys.findIndex(d => d.id === deviceCopy.id)

        if (deviceIndex > -1) {
          this.$set(this.selectedKeys, deviceIndex, deviceCopy)
        } else {
          this.selectedKeys.push(deviceCopy)
        }
        this.$emit('update-keys', this.selectedKeys, this.object, 'keys')
      }

      this.deviceToEdit = null
      this.$refs.editDevice.hide()
    },
    addKeyMethod(device: HandoverDevice) {
      const newDevice = JSON.parse(JSON.stringify(device))
      newDevice.id = Date.now() + '_' + device.name + '_' + Math.random().toString(36).substring(2, 6)
      newDevice.referenceId = this.objectId
      newDevice.ownerId = this.object ? this.object.ownerId : this.accountId || ''
      this.selectedKeys.push(newDevice)
      this.$emit('update-keys', this.selectedKeys, this.object, 'keys')
    },
    addKey() {
      const device: HandoverDevice = {
        id: Date.now() + '_DEVICE_TYPE_LOCKING_KEY_' + Math.random().toString(36).substring(2, 6),
        ownerId: this.object ? this.object.ownerId : this.accountId || '',
        numericId: '99999',
        brand: '',
        referenceId: this.objectId,
        installation: null as ObjectdeviceDevice['installation'],
        uninstallation: null as ObjectdeviceDevice['uninstallation'],
        measureUntil: null as ObjectdeviceDevice['measureUntil'],
        measure: 'DEVICE_MEASURE_UNDEFINED' as ObjectdeviceDevice['measure'],
        type: 'DEVICE_TYPE_LOCKING_KEY' as ObjectdeviceDevice['type'],
        system: 'DEVICE_SYSTEM_UNDEFINED' as ObjectdeviceDevice['system'],
        facilityPlant: 'DEVICE_FACILITY_PLANT_UNDEFINED' as ObjectdeviceDevice['facilityPlant'],
        bkpH: '',
        lifeSpan: -1,
        amount: -1,
        value: '',
        acquisitionCosts: -1,
        unit: 'DEVICE_UNIT_UNDEFINED' as ObjectdeviceDevice['unit'],
        cataloguePrice: -1,
        maintenance: {
          contact: { userReference: '', accountId: '-1', name: '' },
          contract: '',
          costs: { currency: 'CHF', interval: DeviceCostsInterval.UNDEFINED_INTERVAL, amount: 0 },
          lastMaintenance: null,
          nextMaintenance: null,
          subscriptionStart: null,
          subscriptionEnd: null,
          note: ''
        },
        inspection: {
          contact: { userReference: '', accountId: '-1', name: '' },
          contract: '',
          costs: { currency: 'CHF', interval: DeviceCostsInterval.UNDEFINED_INTERVAL, amount: 0 },
          lastOfficialControl: null,
          nextOfficialControl: null,
          subscriptionStart: null,
          subscriptionEnd: null,
          note: ''
        },
        revision: {
          contact: { userReference: '', accountId: '-1', name: '' },
          contract: '',
          costs: { currency: 'CHF', interval: DeviceCostsInterval.UNDEFINED_INTERVAL, amount: 0 },
          lastOfficialRevision: null,
          nextOfficialRevision: null,
          subscriptionStart: null,
          subscriptionEnd: null,
          note: ''
        },
        condition: 'DEVICE_CONDITION_UNDEFINED' as ObjectdeviceDevice['condition'],
        note: '',
        documentIds: [],
        images: [],
        isNewItem: true,
        lockingKey: { combinedKeys: false, combinedKeysNote: '', description: '', lockingPlanNumber: '' } as DeviceLockingKey,
        roomId: ''
      }
      this.selectedKeys.push(device)
      this.$emit('update-keys', this.selectedKeys, this.object, 'keys')
    },
    deviceUpdated(device: HandoverDevice) {
      device.edited = true
      this.deviceToEdit = device
    },
    editDevice(device: HandoverDevice) {
      this.deviceToEdit = { ...device }
      this.internalKey++
      this.$nextTick(() => {
        this.$refs.editDevice.show()
      })
    },
    showDeleteConfirmation(device: HandoverDevice, e: Event) {
      e.preventDefault()
      this.selectedDevice = device
      this.$bvModal.show('confirmationModalDeleteKey_' + this.objectId)
    },
    deleteOneKey() {
      this.$emit('add-init-key')
      if (this.object) {
        this.deletedKeys.push(this.selectedDevice.id || this.selectedDevice.internalId)
      }

      if (this.selectedDevice.roomId) {
        const updatedRooms = [...this.preSelectedRooms]
        const roomIndex = updatedRooms.findIndex(r => r.id === this.selectedDevice.roomId)
        if (roomIndex !== -1) {
          updatedRooms[roomIndex].devices = updatedRooms[roomIndex].devices.filter(
            d => d.id !== this.selectedDevice.id
          )
          this.$emit('selected-rooms', { object: null, rooms: updatedRooms }, this.object, 'device')
        }
      } else {
        this.selectedKeys = this.selectedKeys.filter(d => d.id !== this.selectedDevice.id)
        this.$emit('update-keys', this.selectedKeys, this.object, 'keys', this.selectedDevice.id)
      }

      this.$bvModal.hide('confirmationModalDeleteKey_' + this.objectId)
    },
    addPropertiesToDevices() {
      this.availableKeys.forEach(device => {
        Object.assign(device, {
          id: Date.now() + '_' + device.name + '_' + Math.random().toString(36).substring(2, 6),
          ownerId: this.object ? this.object.ownerId : this.accountId,
          numericId: 99999,
          brand: '',
          referenceId: this.objectId,
          installation: null,
          uninstallation: null,
          measureUntil: null,
          measure: 'DEVICE_MEASURE_UNDEFINED',
          type: device.type,
          system: this.availableSuggestions.find(suggestion => suggestion.type === device.type)?.system || 'DEVICE_SYSTEM_UNDEFINED',
          facilityPlant: this.availableSuggestions.find(suggestion => suggestion.type === device.type)?.facilityPlant || 'DEVICE_FACILITY_PLANT_UNDEFINED',
          bkpH: this.availableSuggestions.find(suggestion => suggestion.type === device.type)?.bkp || '',
          lifeSpan: -1,
          amount: -1,
          value: device.value,
          acquisitionCosts: -1,
          unit: 'DEVICE_UNIT_UNDEFINED',
          cataloguePrice: -1,
          maintenance: { contact: { userReference: '', accountId: -1 }, costs: { currency: 'CHF', interval: 'UNDEFINED_INTERVAL' }, lastMaintenance: null, nextMaintenance: null, subscriptionStart: null, subscriptionEnd: null, note: '' },
          inspection: { contact: { userReference: '', accountId: -1 }, costs: { currency: 'CHF', interval: 'UNDEFINED_INTERVAL' }, lastOfficialControl: null, nextOfficialControl: null, subscriptionStart: null, subscriptionEnd: null, note: '' },
          revision: { contact: { userReference: '', accountId: -1 }, costs: { currency: 'CHF', interval: 'UNDEFINED_INTERVAL' }, lastOfficialRevision: null, nextOfficialRevision: null, subscriptionStart: null, subscriptionEnd: null, note: '' },
          condition: 'DEVICE_CONDITION_UNDEFINED',
          note: '',
          documentIds: [],
          images: [],
          isNewItem: true,
          lockingKey: device.lockingKey
        })
      })
    }
  }
})
</script>

<style lang="scss" scoped>
::v-deep #editDevice .modal-dialog {
  max-width: 80% !important;
}
.save-icon {
  position: absolute;
  right: 20px;
  top: 12px;
  z-index: 9;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card {
  width: 40%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.arrows {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.arrows button {
  margin: 5px;
}

.list-group {
  min-height: 200px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 10px;
  background-color: #fff;
}

.list-group-item {
  padding: 10px;
  margin: 5px 0;
  border: 1px solid #ddd;
  border-radius: 3px;
  cursor: pointer;
  background-color: #f5f5f5;
}

.list-group-item.selected {
  background-color: #d3e2ff;
  border-color: #007bff;
}
.tooltip-message {
  width: 15px;
}
</style>
